import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { AssignLoadToLaneRequest } from '@/types';
import { QUERY_KEYS } from '../../queryKeys';
import { loadlanes } from '../LoadLanes';

export const useAssignLoadToLane = (siteId?: number, customerId?: number) =>
  useMutation({
    mutationFn: (data: AssignLoadToLaneRequest) =>
      loadlanes.assignLoadToLane(data),
    onSuccess: (response) => {
      if (!response.success) return;

      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.loadLanes, siteId, customerId],
      });
    },
  });
